import { Component, model, OnInit, signal, ViewEncapsulation, inject, OnDestroy } from '@angular/core';
import { DocumentTemplateConfirmDeleteViewRowComponent } from './document-template-confirm-delete-view-row/document-template-confirm-delete-view-row.component';
import { MediaBankConfirmDeleteListItemUsesComponent } from '@fi-app/media-bank/media-bank-confirm-delete/media-bank-confirm-delete-list-item-uses/media-bank-confirm-delete-list-item-uses.component';
import { ItemsListElementType } from '@fi-app/components/items-list/items-list-header';
import { DocumentTemplateListData } from './../document-template-list-data.service';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { TemplateModel } from '@fi-app/template/template.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppTextService } from '@fi-shared/app-text';
import { DocumentTemplateService } from '@fi-app/document-template/document-template.service';
import { ItemsListHeader, ItemsListHeaderProperties } from '@fi-app/components/items-list/items-list-header';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { UserService } from '@fi-app/user/user.service';
import { ICreateBase } from '@fi-shared/models/models';
import { ITemplateUsage } from '@fi-app/document-template/document-template';
import { FiDialogsService } from '@fi-shared/fi-dialogs/fi-dialogs.service';
export interface DocumentTemplateConfirmDeleteData {
    selectedItems: TemplateModel[];
    getListDataInstanceFunc?: (isLocal: boolean) => DocumentTemplateListData;
}

export interface IDocumentTemplateUsageTableItem extends ICreateBase {
    Id: number;
    Name: string;
    Usages: ITemplateUsage[];
}

@Component({
    selector: 'fi-document-template-confirm-delete-dialog',
    templateUrl: './document-template-confirm-delete-dialog.component.html',
    styleUrls: ['./document-template-confirm-delete-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DocumentTemplateConfirmDeleteDialogComponent
    extends FiDialogsContentBase<DocumentTemplateConfirmDeleteData, TemplateModel[]>
    implements OnInit, OnDestroy
{
    // loaded$ = new BehaviorSubject(false);
    protected readonly inUseCount = this.data.selectedItems.filter((item) => item.IsInUse).length;
    protected readonly totalCount = this.data.selectedItems.length;
    // listData: DocumentTemplateListData;

    // private appTextService: AppTextService;
    private readonly documentTemplateService = inject(DocumentTemplateService);
    private readonly fiDialogsService = inject(FiDialogsService);
    // private userService: UserService;

    protected loading = signal(false);
    protected templateUsageTableData = signal<IDocumentTemplateUsageTableItem[]>([]);

    public ngOnInit(): void {
        this.loadTemplateUsages();
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.onDestroy$);

        // this.appTextService = this.injector.get(AppTextService);
        // this.userService = this.injector.get(UserService);
        // this.totalCount = this.data.selectedItems.length;
        // this.inUseCount = this.data.selectedItems.filter((item) => item.IsInUse).length;

        // let data: any[] = this.data.selectedItems.map((a) => Object.assign({}, a));

        // data.forEach((file) => {
        //     file.Checked = true;
        // });

        // this.listData = this.data.getListDataInstanceFunc(true);
        // this.listData.Statefull = false;
        // this.listData.loadDataFunc = null;
        // this.listData.loadCountFunc = null;
        // this.listData.ShowFavoriteIcon = false;
        // this.listData.ShowDelete = false;
        // this.listData.RowIsClickable = false;
        // this.listData.Header = [this.listData.Header[0], this.listData.Header[1], this.listData.Header[4]];

        // this.listData.Header[0].Properties.ElementType = ItemsListElementType.ImgIcon;
        // this.listData.Header[1].Properties.ElementType = ItemsListElementType.SpanPlain;
        // this.listData.Header[2].Properties.ElementType = ItemsListElementType.SpanPlain;
        // this.listData.Header[2].Properties.ExtraProperties = {
        //     onClick: ($event, data) => this.userService.openUserViewDialog(data.CreatedByUserId),
        // };

        // this.listData.Header.push(
        //     new ItemsListHeader(
        //         this.appTextService.get('mediaModule.used_in'),
        //         'UsedIn',
        //         new ItemsListHeaderProperties('', false, MediaBankConfirmDeleteListItemUsesComponent),
        //     ),
        // );

        // this.listData.listRowAfterComponentType = DocumentTemplateConfirmDeleteViewRowComponent;

        // this.listData.appendData(data);

        // this.documentTemplateService
        //     .getTemplateUsages(this.data.selectedItems.map((item) => item.Id))
        //     .then((result) => {
        //         let listDataMap = {};
        //         this.listData.Data.forEach((template: any) => {
        //             listDataMap[template.Id] = template;
        //             template.UsesItems = [];
        //         });

        //         result.forEach((item) => listDataMap[item.TemplateId].UsesItems.push(item));

        //         for (let prop in listDataMap) {
        //             listDataMap[prop].UsedIn = listDataMap[prop].UsesItems.length;
        //         }
        //         this.loaded$.next(true);
        //     });
    }
    private loadTemplateUsages(): void {
        this.loading.set(true);
        this.documentTemplateService
            .getTemplateUsages(this.data.selectedItems.map((item) => item.Id))
            .then((result) => this.setTemplateUsageTableData(result));
    }

    private setTemplateUsageTableData(result: ITemplateUsage[]): void {
        const listDataMap = new Map<number, IDocumentTemplateUsageTableItem>();
        this.data.selectedItems.forEach((item) => {
            listDataMap.set(item.Id, {
                Id: item.Id,
                Name: item.Name,
                CreatedByUserId: item.CreatedByUserId,
                CreatedOn: item.CreatedOn,
                CreatedByUserName: item.CreatedByUserName,
                Usages: [],
            });
        });

        result.forEach((item) => {
            if (item.DocumentName && item.DocumentId) {
                const template = listDataMap.get(item.TemplateId);
                listDataMap.set(item.TemplateId, { ...template, Usages: [...template.Usages, item] });
            }
        });

        this.templateUsageTableData.set(Array.from(listDataMap.values()));
        this.loading.set(false);
    }

    private templateIdsToDelete = signal<number[]>([]);
    protected setSelectedItemIdsToDelete($event: number[]): void {
        this.templateIdsToDelete.set($event);
    }

    protected onUsageClick(): void {
        this.fiDialogsService.triggerTransitionCloseDialog$();
    }

    public getResult(): TemplateModel[] {
        const templateIdsToDelete = this.templateIdsToDelete();
        return this.data.selectedItems.filter((item) => templateIdsToDelete.includes(item.Id));
        // let selectedIds = this.listData.SelectedItems.map((item) => item.Id);
        // let deleteItems = this.data.selectedItems.filter((item) => selectedIds.indexOf(item.Id) > -1);
        // return deleteItems;
    }

    public isYesButtonDisabled(): boolean {
        return this.loading() || !this.templateIdsToDelete().length; // !this.loaded$.value || this.listData.SelectedItems.length === 0;
    }

    public onDestroy$ = new Subject<void>();
    public ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
